import OrganizationGoalDetailsModal from 'areas/recommendations/components/OrganizationGoalDetailsModal';
import TabCards from 'common/components/TabCards';
import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

interface SelectGoalProjectProps {
  goalNavData: any[];
  setSelectedGoal: (value: number) => void;
}

const SelectGoalProject: React.FC<SelectGoalProjectProps> = ({ goalNavData, setSelectedGoal }) => {
  const [selectedTabCard, setSelectedTabCard] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any | null>(null);

  const selectGoal = (tabId: number) => {
    setSelectedGoal(goalNavData[tabId].key);
    setSelectedTabCard(tabId);
  };

  const handleOpenModal = (item: any) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  return (
    <Container>
      <TabCards
        onSelect={(item: number) => selectGoal(item)}
        selected={selectedTabCard}
        options={goalNavData.map((item, index) => (
          <Column key={item.key}>
            <Card key={item.key}>
              <Header>{item.header}</Header>
              <CardBodyText title={item.bodyText}>
                {item.bodyText.length > 300 ? `${item.bodyText.slice(0, 300)}...` : item.bodyText}{' '}
                &nbsp;
                <IconWrapper
                  onClick={e => {
                    e.stopPropagation();
                    handleOpenModal(item);
                  }}
                >
                  [<Icon name="external alternate" color="grey" size="small" />
                  more]
                </IconWrapper>
              </CardBodyText>
            </Card>
          </Column>
        ))}
      />

      <OrganizationGoalDetailsModal
        title={selectedItem?.header}
        details={selectedItem?.bodyText}
        context={selectedItem?.context}
        handleCloseModal={handleCloseModal}
        isModalOpen={isModalOpen}
      />
    </Container>
  );
};

export default SelectGoalProject;

// Styled Components

const Container = styled.div`
  display: flex;
  gap: 20px;
  padding-top: 20px;
  justify-content: center;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
`;

const Header = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  color: #414141;
  margin-bottom: 5px;
`;

const Card = styled.div``;

const CardBodyText = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: #555;
  line-height: 1.5;
  max-height: '500px';
  overflow: hidden;
  transition:
    max-height 1s ease-in-out,
    opacity 0.2s ease-in-out,
    visibility 0.6s ease-in-out;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;
